// Navigation mobile
function nav_mobile() {
  $('#nav-mobile-trigger').on('click', function () {
    $('body').toggleClass('menu-open');
    $('#nav-main').toggle();
    var isOpen = $('body').hasClass('menu-open');
    if (isOpen) {
      $('.account-menu').hide();
    }
  });

  $('.link-account, .link-comparateur').on('show.bs.dropdown', function () {
    if ($('body').hasClass('menu-open')) {
      $('#nav-mobile-trigger').trigger('click');
    }
  });
}

// Navigation size
function nav_size() {
  var position = $(window).scrollTop();
  if (position > 220) {
    $('body').addClass('header-small');
  } else {
    $('body').removeClass('header-small');
  }
  $(window).scroll(function () {
    if ($(this).scrollTop() > 220) {
      $('body').addClass('header-small');
    } else {
      $('body').removeClass('header-small');
    }
  });
}

// Navigation sub menu
function nav_sub_menu() {
    var viewport = $(window).width();
    $('#nav-main li[data-navsub] > a').on('click', function(event) {
        var navSub = $(this).parent();
        var isFocus = navSub.hasClass('focus');
        $('#nav-main li[data-navsub]').removeClass('focus');
        if (!isFocus) {
            navSub.addClass('focus');
        }
        event.stopPropagation();
        return false;
    });
    $('html').click(function() {
        $('#nav-main li[data-navsub]').removeClass('focus');
    });
}


// Scroll top button
function scroll_top() {
  $('#btn-back-top').fadeOut(0);
  $(window).scroll(function () {
    if ($(this).scrollTop() > 220) {
      $('#btn-back-top').fadeIn(300);
    } else {
      $('#btn-back-top').fadeOut(300);
    }
  });
  $('#btn-back-top, #sticky-back-top').on('click', function () {
    $('html, body').animate({
      scrollTop: 0
    }, '500');
    return false;
  });
}

function faq_toggle() {
  $('.item-faq .content').hide();
  $('.item-faq .button').on('click', function () {
    var isOpen = $(this).parents().eq(1).hasClass('open');
    if (isOpen) {
      $('.item-faq .content').hide();
      $('.item-faq').removeClass('open');
    } else {
      $('.item-faq .content').hide();
      $('.item-faq').removeClass('open');
      $(this).parent().next().toggle();
      $(this).parents().eq(1).toggleClass('open');
    }
    return false;
  });
}

function filter_toggle() {
  $('#open-list-filter').on('click', function () {
    $('#filter-wp').addClass('open');
    $(this).addClass('close')
  });
  $('#close-list-filter').on('click', function () {
    $('#filter-wp').removeClass('open');
    $('#open-list-filter').removeClass('close')
  });
}

function f_file() {
  $('#custom-file').on('change', function (e) {
    var fileName = $(this).val().split('\\').pop();
    $(this).next().text(fileName);
    $(this).parent().addClass('changed');
  })
}

function f_tabs() {
  $('.car-tabs .button').on('click', function () {
    $('.car-tabs .button').removeClass('active');
    $(this).addClass('active');
    var index = $(this).attr('data-trigger');
    $('.car-tabs .tabs-item').removeClass('show');
    $('.car-tabs .tabs-item[data-index=' + index + ']').addClass('show');
  });

  $('.car-tabs .tabs-nav li:first-child .button').trigger('click');
}

function f_pwdToggleVisibility() {
  $('.password-toggle-visibility').on('click', function () {
    var target = $(this).prev();
    var getType = target.attr('type');
    var strLength = target.val().length * 2;
    $(this).toggleClass('visible');
    $(this).prev().attr('type', getType === 'password' ? 'text' : 'password');
    target.focus();
    target.setSelectionRange(strLength, strLength);
  });
};

function f_tabsFinancement() {
  $('.nav-tab-financement button').on('click', function () {
    $('.nav-tab-financement button').removeClass();
    $('.panel-tab-1, .panel-tab-2').hide();
    $(this).addClass('active');
    var indexTab = $(this).attr('data-tab');
    $(`.panel-tab-${indexTab}`).show();
    return false;
  })
}


// Initialisation
nav_mobile();
nav_sub_menu();
nav_size();
scroll_top();
faq_toggle();
filter_toggle();
f_file();
f_tabs();
f_pwdToggleVisibility();
f_tabsFinancement();

